import { WpnAssign, WPNList, WpnCreate, WpnEdit, WpnView, WpnIssue, WpnDeposit, BulkAssign, UserWpns } from "../Components/Wpn";

import { WpnTypeEdit, WPNType, WpnTypeCreate } from "../Components/WPNType";

export default [
    {
        path: "/wpn-deposit",
        component: WpnDeposit,
        name: "wpn.deposit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/wpn-assign",
        component: WpnAssign,
        name: "wpn.assign",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/user-wpns",
        component: UserWpns,
        name: "user.wpns",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/wpn-bulk-assign",
        component: BulkAssign,
        name: "wpn.bulk.assign",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/wpn",
        component: WPNList,
        name: "wpn.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/wpn/create",
        component: WpnCreate,
        name: "wpn.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/wpn/:id/edit",
        component: WpnEdit,
        name: "wpn.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/wpn/:id",
        component: WpnView,
        name: "wpn.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/wpn/:id/assign",
        component: WpnIssue,
        name: "wpn.assign---",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/wpn-type",
        component: WPNType,
        name: "wpn.type",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/wpn-type/create",
        component: WpnTypeCreate,
        name: "wpn.type.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/wpn-type/:id/edit",
        component: WpnTypeEdit,
        name: "wpn.type.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
